import gql from 'graphql-tag';
import {
  CAREGIVER_SEARCH_RESULT_FIELDS,
  PROVIDER_SEARCH_RESULT_FIELDS,
  JOB_SEARCH_RESULT_FIELDS,
  ARCHIVED_JOB_SEARCH_RESULT_FIELDS,
} from './fragments/common';

const GET_SEARCH_RESULTS = gql`
  ${CAREGIVER_SEARCH_RESULT_FIELDS}
  ${PROVIDER_SEARCH_RESULT_FIELDS}
  ${JOB_SEARCH_RESULT_FIELDS}
  ${ARCHIVED_JOB_SEARCH_RESULT_FIELDS}
  query getSearchResults(
    $seoSegmentId: ID!
    $pageNumber: Int
    $filters: SEOSegmentationFilterInput
    $ipAddress: String!
    $userGeoInfo: String!
    $botInfo: String!
    $userAgent: String!
    $hasFilters: Boolean!
    $numberOfReviewsPerProfile: Int
  ) {
    seoSegmentationSearchResults(
      filters: $filters
      pageNumber: $pageNumber
      testCell: null
      seoSegmentId: $seoSegmentId
      ipAddress: $ipAddress
      botInfo: $botInfo
      userGeoInfo: $userGeoInfo
      userAgent: $userAgent
      numberOfReviewsPerProfile: $numberOfReviewsPerProfile
    ) {
      ... on SEOSegmentationSearchResultsSuccess {
        ...CaregiverSearchResultFields
        ...ProviderSearchResultFields
        ...JobSearchResultFields
        ...ArchivedJobSearchResultFields

        filters @include(if: $hasFilters) {
          location {
            zipcode
            city
            state
          }
        }
      }
      ... on SEOSegmentationSearchResultsError {
        errors {
          __typename
          message
        }
      }
    }
    seoSegmentationDetails(seoSegmentId: $seoSegmentId) {
      __typename
      ... on SEOSegmentationDetailsSuccess {
        segmentationDetails {
          searchResultsHeader
        }
      }
    }
  }
`;

export default GET_SEARCH_RESULTS;
